class ArrayExtensions {
    
  /**
   * Joins an array into a string with options to include/exclude whitespace-only, empty, and null values.
   *
   * Example:
   *   ArrayExtension.join([1, null, 3, '', 5]) // '1, 3, 5'
   *
   * @param {Array<any>} values - The collection of values to join.
   * @param {Object} [options] - Optional settings.
   * @param {string} [options.separator=', '] - The separator to use between values.
   * @param {boolean} [options.ws=false] - Include whitespace-only strings.
   * @param {boolean} [options.e=false] - Include empty strings.
   * @param {boolean} [options.n=false] - Include null values.
   * @param {string} [options.d='N/A'] - Default value if result is empty or null.
   * 
   * @returns {string} A string with the joined values, filtered based on the provided flags.
   */
  static join(
    values,
    {
      separator = ', ',
      ws = false,
      e = false,
      n = false,
      d = 'N/A'
    } = {}
  ) {
    if (!Array.isArray(values)) return d;

    const filtered = values.filter(v => {
      const str = v?.toString();
      return (n || v != null) &&
             (e || str !== '') &&
             (ws || (str && str.trim() !== ''));
    });
  
    const result = filtered.join(separator);
    return result || d;
  }
  
}

export { ArrayExtensions }
